import { render } from "./PaginationVideos.vue?vue&type=template&id=168ba449&scoped=true"
import script from "./PaginationVideos.vue?vue&type=script&lang=ts"
export * from "./PaginationVideos.vue?vue&type=script&lang=ts"

import "./PaginationVideos.vue?vue&type=style&index=0&id=168ba449&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-168ba449"

export default script